import { NotesDisplay } from '@kanda-libs/ks-component-ts';
import { BreakPoints } from '@kanda-libs/ks-design-library';

import { FormattedJob } from 'types';

import { DownloadButton, Header, LineItems, Totals } from './components';

interface ViewComponentProps {
  /**
   *
   */
  showLineItems?: boolean;
  job?: FormattedJob;
}

const ViewComponent = ({ showLineItems, ...props }: ViewComponentProps) => {
  const [notes] = props.job?.notes || [];

  return (
    <div className="flex flex-col">
      <Header {...props} />
      <BreakPoints
        mobile={
          <>
            <LineItems {...props} />
            <Totals {...props} />
          </>
        }
        desktop={
          showLineItems ? (
            <>
              <LineItems {...props} />
              <Totals {...props} />
            </>
          ) : undefined
        }
      />
      {notes && (
        <div className="mb-7">
          <NotesDisplay compact note={notes} />
        </div>
      )}
      <DownloadButton />
    </div>
  );
};

ViewComponent.displayName = 'JobDetails-view';

ViewComponent.defaultProps = {
  showLineItems: true,
};

export default ViewComponent;
